export default "/static/img/icons/file-download-solid.f4235b4d014ace4854b75a818cbb24ed.svg";